import * as React from 'react';

function SvgClone(props) {
  return (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6 4a1 1 0 011-1h8a1 1 0 011 1v9a1 1 0 01-1 1H7a1 1 0 01-1-1V4z"
        fill="currentColor"
        opacity={0.6}
      />
      <path
        d="M4 6a1 1 0 011-1h8a1 1 0 011 1v9a1 1 0 01-1 1H5a1 1 0 01-1-1V6z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgClone;
